import type { VideoEditorProps } from "@perceptron/core";

// Keep app-owned URLs out of shared Core defaults. Player and warmer must share this configuration.
export const DEMO_NANO_MODEL_URLS = {
  backbone: "/demo/models/nanotrack/nanotrack_backbone.onnx",
  head: "/demo/models/nanotrack/nanotrack_head.onnx",
  wasm: "https://cdn.jsdelivr.net/npm/onnxruntime-web@1.24.3/dist/",
} satisfies NonNullable<VideoEditorProps["nanoModelUrls"]>;
